import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'components/Form';
import Icon from 'components/Icon';
import NotAuthorizedLayout from 'layouts/NotAuthorized';
import { Rhythm } from 'components/Layout/Rhythm';

export default ({
  text,
}) => (
  <NotAuthorizedLayout title={text}>
    <Rhythm center>
      <Link to="/">
        <Button
          title="Go to my dashboard!"
        />
      </Link>
    </Rhythm>
  </NotAuthorizedLayout>
);
